import React from 'react'
import Layout from '@/components/Layout'
import Seo from '@/components/Seo'
import { graphql } from 'gatsby'
import { Blocks, Head } from '@/components/WordPress'
import styled from '@emotion/styled'
import { h3, graphTitle, h4, h5, pStandard, caption } from '@/styles/typography'
import Embed16x9 from '@/components/UI/Embed16x9'
import ArticleCard from '@/components/Articles/Card'

const Content = styled.div`
  padding-top: 8rem;
  header {
    text-align: center;
    h1 {
      ${h3}
      padding-left: 2rem;
      padding-right: 2rem;
      margin-bottom: 2rem;
      @media (max-width: 768px) {
        padding-left: 1rem;
        padding-right: 1rem;
      }
    }
    .excerpt {
      max-width: 1300px;
      margin-left: auto;
      margin-right: auto;
      padding-left: 2rem;
      padding-right: 2rem;
      margin-bottom: 2rem;
      @media (max-width: 768px) {
        padding-left: 1rem;
        padding-right: 1rem;
      }
      p {
        ${graphTitle};
      }
    }
  }

  .content {
    p {
      ${pStandard};
      text-align: justify;
      text-indent: 2em;
      &.has-drop-cap {
        text-indent: 0;
        &::first-letter {
          font-size: 6.6rem;
          line-height: 5.9rem;
          font-weight: 800;
          float: left;
          margin-right: 0.2rem;
        }
      }
    }
    .wp-block {
      max-width: 700px;
      margin-left: auto;
      margin-right: auto;
      padding-left: 1rem;
      padding-right: 1rem;
      &.block--image {
        max-width: 1280px;
        padding-left: 0;
        padding-right: 0;
        margin-bottom: 3rem;
        margin-top: 2rem;
        figcaption {
          padding-left: 0.1em;
          padding-right: 0.1em;
          padding-top: 6px;
          ${caption}
          @media (orientation: portrait) {
            font-size: 0.9rem;
          }
          &:before {
            content: '▲';
            display: inline-block;
            margin-right: 4px;
            margin-left: 4px;
          }
        }
      }
    }
    .block--heading {
      h2 {
        ${h4};
        padding-bottom: 0.5em;
        text-align: center;
        margin-top: 0.3em;
      }
    }
  }
`

const MoreArticles = styled.div`
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;

  h3 {
    padding-left: 1rem;
    padding-right: 1rem;
    margin-top: 2rem;
    margin-bottom: 1rem;
    ${h5};
  }
`

const PostTemplate = ({
  data: {
    wpPost: {
      excerpt,
      featuredImage,
      title,
      rawContent,
      slug,
      postFormats,
      videofields,
    },
    allWpPost,
  },
}) => {
  const video = videofields?.iframe
  return (
    <Layout>
      <Seo title={''} />
      <Content>
        <header>
          <Head title={title} excerpt={excerpt} />
        </header>
        {video && <Embed16x9 iframe={video}></Embed16x9>}
        <div className="content">
          <Blocks raw={rawContent} />
        </div>
      </Content>
      <MoreArticles>
        <h3>Otros artículos</h3>
        {allWpPost.edges
          .filter(item => item.node.slug !== slug)
          .map((edge, index) => (
            <ArticleCard
              key={edge.node.slug}
              odd={index % 2 === 0}
              title={edge.node.title}
              excerpt={edge.node.excerpt}
              slug={edge.node.slug}
              featuredImage={edge.node.featuredImage}
              type={
                edge.node.postFormats?.nodes[0]?.name === 'Video'
                  ? 'video'
                  : 'article'
              }
            />
          ))}
      </MoreArticles>
    </Layout>
  )
}

export const postQuery = graphql`
  query PostBySlug($slug: String!) {
    wpPost(slug: { eq: $slug }) {
      title
      rawContent
      slug
      excerpt
      featuredImage {
        node {
          localFile {
            childImageSharp {
              fluid(maxWidth: 1000) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
      postFormats {
        nodes {
          name
        }
      }
      videofields {
        iframe
      }
    }
    allWpPost(
      filter: { categories: { nodes: { elemMatch: { name: { eq: "MGZX" } } } } }
    ) {
      edges {
        node {
          slug
          title
          excerpt
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: CONSTRAINED, quality: 90)
                }
              }
            }
          }
          postFormats {
            nodes {
              name
            }
          }
        }
      }
    }
  }
`

export default PostTemplate
